import axiosInstance from "utils/AxiosInterceptor";
import {
  ActivationAccountRequest,
  SendEmailRequest,
  LoginRequest,
  LoginResponse,
  RegisterRequest,
  ResetPassowrdRequest,
  PasswordUpdateRequest,
  UpdateAnagraficaRequest,
} from "../interfaces";

export const login = async (payload: LoginRequest) => {
  return axiosInstance.post<LoginResponse>("api/auth/login", payload);
};
export const sendEmailRegister = async (payload: RegisterRequest) => {
  return axiosInstance.post("api/auth/register", payload);
};
export const sendEmailResetPassword = async (payload: SendEmailRequest) => {
  return axiosInstance.post("api/auth/reset-password", payload);
};
export const activationEmail = async (payload: SendEmailRequest) => {
  return axiosInstance.post("api/auth/resend-activation-email", payload);
};
export const resendEmailResetPassword = async (payload: SendEmailRequest) => {
  return axiosInstance.post("api/auth/resend-reset-password-email", payload);
};
export const activationAccount = async (payload: ActivationAccountRequest) => {
  return axiosInstance.post("api/auth/activate-account", payload);
};
export const resetPassword = async (payload: ResetPassowrdRequest) => {
  return axiosInstance.post("api/auth/confirm-reset-password", payload);
};
export const verifyToken = async (token: string) => {
  return axiosInstance.post("api/auth/check-token", { token: token });
};
export const verifyTokenResetPassword = async (token: string) => {
  return axiosInstance.post("api/auth/check-token-reset-password", {
    token: token,
  });
};
export const logout = async () => {
  return axiosInstance.get("api/auth/logout");
};

export const updatePassword = async (payload: PasswordUpdateRequest) => {
  return axiosInstance.put("api/auth/update-password", payload);
};

export const deleteAccount = async (password: { password: string }) => {
  return axiosInstance.post(`api/auth/delete`, password);
};

export const updateAnagrafica = async (payload: UpdateAnagraficaRequest) => {
  return axiosInstance.put("api/auth/update", payload);
};
